import React from 'react';
import { InputItem } from 'antd-mobile';
import Captialize from './Capitalize';
import './index.less';
const isIOS = /iphone|iPhone|ipad|ipod|ios/i.test(navigator.userAgent);

class NumberEl extends React.PureComponent{
    render(){
        let { length, decimal_places, captialize, form, extra, errorText,api_name, is_readonly, default_value, is_required, auto_adapt_places} = this.props;
        
        const { getFieldProps } = form;
        
        let tempProps = {
            name: api_name,
            disabled: is_readonly,
            placeholder: $st('请输入')
        }
        let fieldProps = getFieldProps(api_name, {
            initialValue: default_value,
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required,
                    message: $st(`该项是必填项`)
                }],
            }],
            normalize: function(v, prev){
                v = v && v.trim()
                if(!v) return v;
                //校验是否是数字
                let _n = Number(v)
                if(isNaN(_n) || typeof _n  !== 'number') {
                    return prev;
                }

                let val = v.split('.')
                if(val.length > 2) return prev; //不合法，例如1.2.3

                let num = val[0] || 0, decimal = val[1];

                // 整数部分判断
                if ( (num + '').length > length ) return prev;
                
                //小数部分判断
                if (decimal && decimal.length > decimal_places) {
                    if (v === '.') {
                       return '0.';
                    }
                    return prev;
                }
                return v;
            }
        });
        let value = form.getFieldValue(api_name);
        let numberClass = isIOS ? 'iosColor' : ''
        return (
            <div className={'number' + (captialize ? ' money': '')}>
                <InputItem className={numberClass} {...tempProps}  {...fieldProps} /> 
                <span className="number__extra">{captialize ? '￥' : extra}</span>
                {captialize ? <Captialize className="number__capitalize" value={value} /> : null}
                {errorText && <div className='input-error'>{errorText}</div>}
            </div>
        )
    }
};

export default NumberEl;


// WEBPACK FOOTER //
// ./src/component/Number/Number.js